<template>
  <header>
    <div role="navbar" class="navbar">
      <div class="logo"><img :src="logo_img" alt="" /></div>
      <div><button class="try-it">Try It Free</button></div>
    </div>
    <div class="header-content">
      <div class="header-txt">
        <h2 class="header-title">Build The Community Your Fans Will Love</h2>
        <p class="header-text">
          Huddle re-imagines the way we build communities. You have a voice, but
          so does your audience. Create connections with your users as you
          engage in genuine discussion.
        </p>
        <my-button class="btn"></my-button>
      </div>
      <div class="header-img">
        <img :src="header_img" alt="" />
      </div>
    </div>
  </header>
</template>
<script>
import MyButton from "./myButton.vue";
export default {
  name: "MyHeader",
  data: function () {
    return {
      logo_img: require("/src/assets/logo.svg"),
      header_img: require("/src/assets/illustration-mockups.svg"),
    };
  },
  components: {
    MyButton,
  },
};
</script>

<style scoped>
.navbar {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-content: center;
}

.try-it {
  background-color: white;
  border-radius: 1rem;
  padding: 0.3rem 0.7rem;
  font-size: 13px;
  font-weight: 700;
  border-style: initial;
}
h2 {
  font-weight: 700;
  
  margin-bottom: 1.5rem;
}
p {
  padding: 5px;
}
.header-content {
  display: flex;
  margin-top: 3rem;
  flex-basis: 100%;
}
.header-img img {
  width: 100%;
}.btn{
  margin-top: 2rem;
}

@media (max-width: 720px) {
  .header-content {
    flex-direction: column;
  }
  header {
    background-image: url("/src/assets/bg-hero-mobile.svg");
    padding: 2rem;
    background-color:hsl(193, 100%, 96%);
  }
  .logo img {
    width: 6rem;
  }
  .btn{
      margin: 2rem 2.3rem ;
  }h2{
      text-align: center;
  }
  p{
    text-align: center;

  }.header-img{
    margin-top: 2rem;
  }
}
@media (min-width: 721px) {
  .header-content {
    flex-direction: row;
  }
  header {
    background-image: url("/src/assets/bg-hero-desktop.svg");
    padding: 5rem 8rem;
     background-color:hsl(193, 100%, 96%);
  }
  .logo img {
    width: 10rem;
  }
} ;
</style>